import parseExperimentCookies from './parseExperimentCookies';

export type BrowserExperimentAssignment = {
  experimentId: string;
  version: number;
  browserKey: string;
  assignedAt: string;
};

export default function readBrowserExperimentAssignments(): BrowserExperimentAssignment[] {
  const { browserKey, assignments } = parseExperimentCookies(document.cookie);

  if (!browserKey) {
    return [];
  }

  return Object.entries(assignments).map(([experimentId, assignment]) => ({
    experimentId,
    version: assignment.version,
    browserKey,
    assignedAt: assignment.assignedAt,
  }));
}
